import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const UserManagement = () => {
  return <SingleContentPage title="User Management" moduleKey="user-management" />;
};

export default UserManagement;
